<template>
    <div class="campaign-search-autocomplete">
        <v-menu v-model="show" offset-y
                :max-width="!$utils.isMobile() ? '290' : ''"
                :min-width="!$utils.isMobile() ? '290' : ''"
                max-height="290"
                content-class="campaign-autocomplete-list">
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-on="on"
                    v-model="model"
                    :placeholder="$t('searchCampaign') | capitalize"
                    class="ma-0 pa-0 input-search"
                    @input="searchNow()"
                    @keyup.enter="emitData()"
                    @click:append="emitData()"
                ></v-text-field>
                <img src="/img/scenario/search.svg" alt="icon-search" class="icon-search" @click="emitData()" style="cursor: pointer">
            </template>
            <v-list v-if="showList && items.length > 0">
                <v-list-tile
                    v-for="(item, index) in items"
                    :key="index"
                    @click="emitCampaign(item)"
                >
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
import CampaignService from '@/services/campaign.service'

export default {
    name: 'SearchCampaign',
    props: {
        keyword: {
            type: String,
            default: ''
        },
        limit: {
            type: Number,
            default: 15
        },
        orderBy: {
            type: String,
            default: 'title'
        },
        sortDirection: {
            type: String,
            default: 'desc'
        },
        showList: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            items: [],
            model: this.keyword,
            isLoading: false,
            delay: false,
            show: false
        }
    },
    methods: {
        emitData() {
            this.show = false
            this.items = []
            this.$emit('input', this.model)
        },
        emitCampaign(item) {
            if (item.id && item.id !== '') {
                this.$emit('campaign-selected', item)
            }
        },
        searchNow() {
            if (this.model === '') {
                this.items = []
                return
            }
            if (this.delay) {
                clearTimeout(this.delay)
                this.isLoading = false
            }
            this.isLoading = true
            this.delay = setTimeout(() => {
                let order = this.sortDirection === 'desc' ? '-' + this.orderBy : this.orderBy
                CampaignService.getCampaigns(this.limit, 1, order, this.model).then(res => {
                    this.items = [...res.data.data]
                    clearTimeout(this.delay)
                    this.isLoading = false
                    this.show = true
                    if (!this.items.length) {
                        this.items.push({
                            id: '',
                            title: 'No Result'
                        })
                    }
                }, error => {
                    clearTimeout(this.delay)
                    this.isLoading = false
                })
            }, 500)
        }
    },
    beforeDestroy() {
        this.items = []
        this.model = ''
    },
    watch: {
        keyword() {
            this.model = this.keyword
        }
    }
}
</script>
<style scoped lang="scss">
.campaign-search-autocomplete {
    position: relative;
}

.icon-search {
    position: absolute;
    right: 10px;
    top: 7px;
    width: 16px;
}

::v-deep {
    .input-search {
        .v-input__slot {
            padding-right: 30px !important;
        }
    }

    .v-input__slot {
        margin: 0;
    }

    .v-text-field__details {
        display: none
    }

    .v-text-field .v-input__append-inner {
        margin-top: 2px !important;
    }
}
</style>
